
export class GiftCardPhysicalStatsDto {
    all: number;
    processed: number;
    notProcessed: number;
}